import React from 'react';
import { View } from 'react-native';
import { Button, ButtonIcon, ButtonText } from '@/components/gluestack/button';
import { ChevronDownIcon } from '@/components/gluestack/icon';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';
import { GlobeIcon } from '@hugeicons-pro/core-solid-rounded';
import { useLanguage } from '@/hooks/useLanguage';
import { CountryFlagIcon } from '@/components/ui/CountryFlagIcon';
import { MenuSelectButton } from '@/components/ui/MenuSelectButton';

type Size = 'xs' | 'sm' | 'md' | 'lg';

export default function LanguageSelector({ size = 'md', neutral, iconOnly = false, hideDefaultIcon = false }: { size?: Size; neutral?: boolean; iconOnly?: boolean; hideDefaultIcon?: boolean }) {
  const { selectedLanguage, updateLanguage, supportedLanguages, getCurrentLanguageDisplay } =
    useLanguage();

  const availableLanguages = Object.keys(supportedLanguages);

  const languageToCountry: Record<string, string> = {
    en: 'us',
    es: 'es',
    fr: 'fr',
    it: 'it',
    pt: 'pt',
    de: 'de',
  };

  const selectedFlagCode = selectedLanguage !== 'default' ? (languageToCountry[selectedLanguage] || 'xx') : null;
  const showDefaultGlobe = selectedFlagCode === null && !hideDefaultIcon;

  return (
    <MenuSelectButton
      selectedKey={selectedLanguage}
      options={availableLanguages.map((langCode) => ({
        key: langCode,
        label: supportedLanguages[langCode as keyof typeof supportedLanguages],
        leftAccessory:
          langCode === 'default' ? (
            <HugeIconsWrapper icon={GlobeIcon} size={18} className="color-typography-700" />
          ) : (
            <CountryFlagIcon countryCode={languageToCountry[langCode] || 'xx'} size={18} />
          ),
      }))}
      onSelect={(key) => updateLanguage(key as any)}
      placement="bottom right"
      offset={8}
      trigger={({ ...triggerProps }) => (
        <Button
          {...triggerProps}
          size={size}
          className={iconOnly ? 'gap-0 px-2' : 'gap-2'}
          action={neutral ? 'neutral' : undefined}>
          {iconOnly ? (
            selectedFlagCode ? (
              <CountryFlagIcon countryCode={selectedFlagCode} size={20} />
            ) : showDefaultGlobe ? (
              <HugeIconsWrapper
                icon={GlobeIcon}
                size={20}
                className={neutral ? 'color-typography-500' : 'color-white'}
              />
            ) : null
          ) : (
            <>
              {selectedFlagCode ? (
                <CountryFlagIcon countryCode={selectedFlagCode} size={20} />
              ) : showDefaultGlobe ? (
                <HugeIconsWrapper
                  icon={GlobeIcon}
                  size={20}
                  className={neutral ? 'color-typography-500' : 'color-white'}
                />
              ) : null}
              <ButtonText>{getCurrentLanguageDisplay()}</ButtonText>
              <ButtonIcon
                as={ChevronDownIcon}
                size="sm"
                className={neutral ? 'color-typography-500' : 'color-white'}
              />
            </>
          )}
        </Button>
      )}
    />
  );
}


